import {
    DELETE_PROCESS_STATEMENT_COMMENT_REQUEST,
    deleteProcessStatementCommentSuccess,
    deleteProcessStatementCommentFailure,
    showNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

export const deleteProcessStatementCommentEpic = (action$, store$, { ProcessStatementRepository }) => {
    return action$.pipe(
        ofType(DELETE_PROCESS_STATEMENT_COMMENT_REQUEST),
        mergeMap(action => from(ProcessStatementRepository.deleteComment( action.payload.processStatementId, action.payload.processStatementComment ))
            .pipe(
                mergeMap(statement => {
                    return from([
                        showNotification(`Stellungnahme-Kommentar wurde erfolgreich gelöscht.`),
                        deleteProcessStatementCommentSuccess(statement),
                    ]);
                }),
                catchError( error => {
                    return from([
                      deleteProcessStatementCommentFailure(error),
                    ])
                })
            )
        ),
    );
}
